import { Extension } from "@tiptap/core";

const DeleteListOnBackspace = Extension.create({
    addKeyboardShortcuts() {
        return {
            Backspace: ({ editor }) => {
                const { state, commands } = editor;
                const { doc, selection } = state;
                const { empty, from } = selection;

                // Only proceed if selection is empty (i.e., caret, not a range)
                if (!empty) {
                    return false;
                }

                // Check if there's only one bulletList with one listItem and one paragraph
                if (
                    doc.content.childCount === 1 &&
                    doc.content.firstChild.type.name === "bulletList" &&
                    doc.content.firstChild.content.childCount === 1 &&
                    doc.content.firstChild.firstChild.type.name === "listItem"
                ) {
                    const paragraph =
                        doc.content.firstChild.firstChild.firstChild;

                    // If paragraph is empty and selection is at position 2 (after the bullet + space)
                    if (
                        paragraph &&
                        paragraph.type.name === "paragraph" &&
                        paragraph.textContent === "" &&
                        from === 3
                    ) {
                        // Clear the document
                        commands.clearContent();
                        return true; // Handled
                    }
                }

                return false; // Let default behavior run otherwise
            },
        };
    },
});

export { DeleteListOnBackspace };
